/*
 * action types
 */

export const SET_CERT_SELECTED = 'SET_CERT_SELECTED';

export let certSelected = (meta_case_number) => {
	return { type: SET_CERT_SELECTED, meta_case_number };
};
